import { AxeEvent, CollateralBasketType, OrderTerm, RepoType, TradingType } from 'api'
import { getEnumValues } from 'model'

import { AxeDetail } from 'selectors/axeSelectors'

export const canPerformEvent = (axeDetail: AxeDetail, event: AxeEvent) => axeDetail.availableEvents.includes(event)

export const canEditCurrency = (axeDetail: AxeDetail) => axeDetail.productSector?.basketType === CollateralBasketType.EUROCLEAR

export const canEditStartConsideration = (axeDetail: AxeDetail) => {
  return axeDetail.instrument?.tradingType !== TradingType.NOTIONAL && axeDetail.productSector?.basketType !== CollateralBasketType.DBV
}

export const canEditNotional = (axeDetail: AxeDetail) => {
  return axeDetail.instrument?.tradingType !== TradingType.CASH || axeDetail.productSector?.basketType === CollateralBasketType.DBV
}

export const canEditFee = (axeDetail: AxeDetail) => axeDetail.axe.repoType === RepoType.STOCK_BORROWING_LENDING

export const canEditRate = (axeDetail: AxeDetail) => axeDetail.axe.repoType !== RepoType.STOCK_BORROWING_LENDING

export const axeDetailIsSBL = (axeDetail: AxeDetail) => axeDetail.axe.repoType === RepoType.STOCK_BORROWING_LENDING

export const OPEN_ORDER_TERM_KEYS = getEnumValues(OrderTerm).filter(k => /.*_O/.test(k))

export const getExcludedTermOptionKeys = (axeDetail: AxeDetail) =>
  axeDetail.productSector?.basketType === CollateralBasketType.GC_PLUS ? OPEN_ORDER_TERM_KEYS : []
